const symptomCheckerPage = document.querySelector('.page-template-page-template-symptom-checker');
const question1 = document.getElementById('question-1');
const theStart = document.getElementById('primary');
const outcomeEl = document.getElementById('outcomes');
const startBtn = document.querySelector('.symptom-checker-intro a');
const startArrow = document.getElementById('sc-arrow1');
const outcomeArrow = document.getElementById('sc-arrow2');

if(symptomCheckerPage) {
    question1.classList.add("on");

    setTimeout(function() {
        question1.classList.add("active");
    }, 400);
    
    startBtn.addEventListener('click', function(event) {
        startArrow.classList.add("active");
    });
    
    const questions = [
        {
            id: 'question-1',
            next_question: {
                'answer-1': 'question-3',
                'answer-2': 'question-2',
                'answer-3': 'question-2',
              }
        },
        {
            id: 'question-2',
            next_question: {
                'answer-1': 'question-3',
                'answer-2': 'question-3',
                'answer-3': 'question-5',
                'answer-4': 'question-8',
                'answer-5': 'question-15',
                'answer-6': 'question-15',
              }
        },
        {
            id: 'question-3',
            next_question: {
                'answer-1': 'bv-standard',
                'answer-2': 'question-4',
                'answer-3': 'bv-standard',
              }
        },
        {
            id: 'question-4',
            next_question: {
                'answer-1': 'bv-standard',
                'answer-2': 'bv-standard',
              }
        },
        {
            id: 'question-5',
            next_question: {
                'answer-1': 'question-6',
                'answer-2': 'question-9',
              }
        },
        {
            id: 'question-6',
            next_question: {
                'answer-1': 'thrush-standard',
                'answer-2': 'question-7',
                'answer-3': 'question-7',
              }
        },
        {
            id: 'question-7',
            next_question: {
                'answer-1': 'thrush-standard',
                'answer-2': 'thrush-standard',
              }
        },
        {
            id: 'question-8',
            next_question: {
                'answer-1': 'question-6',
                'answer-2': 'question-9',
              }
        },
        {
            id: 'question-9',
            next_question: {
                'answer-1': 'question-10',
                'answer-2': 'question-10',
              }
        },
        {
            id: 'question-10',
            next_question: {
                'answer-1': 'question-11',
                'answer-2': 'question-11',
              }
        },
        {
            id: 'question-11',
            next_question: {
                'answer-1': 'question-12',
                'answer-2': 'question-12',
              }
        },
        {
            id: 'question-12',
            next_question: {
                'answer-1': 'question-13',
                'answer-2': 'trich-standard',
              }
        },
        {
            id: 'question-13',
            next_question: {
                'answer-1': 'trich-standard',
                'answer-2': 'question-14',
                'answer-3': 'trich-standard',
              }
        },
        {
            id: 'question-14',
            next_question: {
                'answer-1': 'trich-menopause',
                'answer-2': 'trich-standard',
              }
        },
        {
            id: 'question-15',
            next_question: {
                'answer-1': 'question-16',
                'answer-2': 'question-9',
                'answer-3': 'question-18',
              }
        },
        {
            id: 'question-16',
            next_question: {
                'answer-1': 'thrush-standard',
                'answer-2': 'question-17',
                'answer-3': 'thrush-standard',
              }
        },
        {
            id: 'question-17',
            next_question: {
                'answer-1': 'thrush-menopause',
                'answer-2': 'thrush-standard',
              }
        },
        {
            id: 'question-18',
            next_question: {
                'answer-1': 'soothing-cream',
                'answer-2': 'question-19',
                'answer-3': 'soothing-cream',
              }
        },
        {
            id: 'question-19',
            next_question: {
                'answer-1': 'moisturiser-menopause',
                'answer-2': 'soothing-cream',
              }
        },
    ];
    
    const buttons = document.querySelectorAll('.symptom-checker__a');
    const prevButtons = document.querySelectorAll('.previous-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', function(event) {
        const questionId = event.target.getAttribute('data-question-id');
        const answerId = event.target.getAttribute('data-answer-id');
    
        const question = document.getElementById(questionId);
        const activeOutcome = document.querySelector('.symptom-checker__outcomes.active');
    
        const questionObj = questions.find(item => item.id === questionId);
    
        const nextQuestionObj = questionObj.next_question[answerId];
    
        function removeActiveOutcome() {
            if(activeOutcome) {
                activeOutcome.classList.remove("active");
            }
        }
    
        const nextQuestion = document.getElementById(nextQuestionObj);

        //add this question id to previous button of next question
        const nextQuestionsPrevBtn = document.getElementById('previous-' + nextQuestionObj);
        
        if(nextQuestionsPrevBtn) {
            nextQuestionsPrevBtn.setAttribute('data-previous', questionId);
        }
    
        let outcome = '';
    
        if(nextQuestion.classList.contains('symptom-checker__outcomes')) {
            outcome = nextQuestion;
        }
    
        if(outcome) {
            removeActiveOutcome();
            outcomeEl.scrollIntoView({ behavior: "smooth" });
            symptomCheckerPage.classList.add("scroll");
            outcomeArrow.classList.add("active");
            outcome.classList.add('active');
        } else {
            if(nextQuestion) {
                question.classList.add("goaway");
    
                setTimeout(function() {
                    question.classList.remove("on");
                    nextQuestion.classList.add('on');
                }, 800);
    
                setTimeout(function() {
                    nextQuestion.classList.add('active');
                }, 850);
            }
        }
    
      });
    });

    prevButtons.forEach(prevButton => {
        prevButton.addEventListener('click', function(event) {
          const question = document.querySelector('.symptom-checker__qa.on.active');
          const prevQuestionId = event.target.getAttribute('data-previous');
          const prevQuestion = document.getElementById(prevQuestionId);
      
            if(prevQuestion) {
                question.classList.remove("active");

                setTimeout(function() {
                    question.classList.remove("on");
                    prevQuestion.classList.add('on');
                }, 800);

                setTimeout(function() {
                    prevQuestion.classList.remove("goaway");
                }, 850);
            } else {
                theStart.scrollIntoView({ behavior: "smooth" });
            }
      
        });
      });


}


